
<template>
  <div>
    <b-sidebar visible id="sidebar-no-header" no-header>
      <nav>
        <b-nav vertical>
          <b-nav-item>
            <a>
              <span @click="changeComponent('events')">
                <i class="fa fa-fw fa-video-camera"></i> Events
              </span>
            </a>
          </b-nav-item>

          <b-nav-item>
            <a>
              <span @click="changeComponent('profile')">
                <i class="fa fa-fw fa-video-camera"></i> Profile
              </span>
            </a>
          </b-nav-item>

          <b-nav-item v-if="isAdmin">
            <a>
              <span @click="changeComponent('adminPanel')">
                <i class="fa fa-unlock-alt fa-fw"></i> Admin Panel
              </span>
            </a>
          </b-nav-item>
        </b-nav>
      </nav>
    </b-sidebar>
  </div>
</template>

<style lang="css" scoped>
#sidebar-no-header {
  padding-top: 10em;
  width: auto;
}
</style>

<script>
export default {
  computed: {
    isAdmin() {
      return this.$store.state.isAdmin;
    }
  },
  methods: {
    changeComponent(component) {
      this.$store.commit("CHANGE_COMPONENT", component);
    }
  }
};
</script>


        

